import { render, staticRenderFns } from "./SubDepartment.vue?vue&type=template&id=8a70da96"
import script from "./SubDepartment.vue?vue&type=script&lang=js"
export * from "./SubDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports